import PriceListItem, { PriceListItemProps } from './PriceListItem';

export type { PriceListItemProps };
export default PriceListItem;
